import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { FormContext } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'
import { createTaskFormSchema } from 'modules/workflows/components/Sidepanel/schemas/taskFormSchema'

export const createBasicTaskHandlerSchema = (formContext: FormContext) =>
  createTaskFormSchema(formContext).extend({
    nodeData: z.object({
      handlerType: z.literal('create_manual_task'),
      payload: z.object({
        title: z.string().min(1, {
          message: i18n.t('procurement.workflows.basic_task_handler.validation.title_required'),
        }),
        description: z.string().min(1, {
          message: i18n.t(
            'procurement.workflows.basic_task_handler.validation.description_required'
          ),
        }),
        assignee_ids: z.array(z.number()).min(1, {
          message: i18n.t('procurement.workflows.basic_task_handler.validation.assignee_required'),
        }),
        due_on_value: z
          .number({
            message: i18n.t(
              'procurement.workflows.basic_task_handler.validation.due_date_min_value'
            ),
          })
          .min(1, {
            message: i18n.t(
              'procurement.workflows.basic_task_handler.validation.due_date_min_value'
            ),
          }),
        due_on_unit: z.enum(['hours', 'days', 'weeks', 'months']),
        category: z.literal('finance'),
      }),
    }),
  })

export type BasicTaskHandlerSchema = z.infer<ReturnType<typeof createBasicTaskHandlerSchema>>
